import type { RouteRecordRaw } from 'vue-router'
import { routeNames, routePaths } from '@/router/router-constants'

export const emailCampaignRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.emailCampaigns,
    name: routeNames.emailCampaigns,
    component: () => import('@/pages/email-campaigns/EmailCampaignsView.vue'),
    meta: {
      permission: 'email-campaigns.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'mail',
      labelKey: 'emailCampaigns',
      featureFlag: 'email-campaigns',
    },
  },
  {
    path: routePaths.emailCampaignDetails,
    name: routeNames.emailCampaignDetails,
    component: () => import('@/pages/email-campaigns/EmailCampaignsDeatilsView.vue'),
    meta: {
      permission: 'email-campaigns.read.all',
      rootRouteName: routeNames.emailCampaigns,
      featureFlag: 'email-campaigns',
    },
  },
]
